/**
 * Provider for `browserVersion`
 * @module
 */

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'browserVersion',

  getter: [
    'sources/browser_id',
    /**
     * @return {string}
     */
    function(BrowserIdSource) {
      return BrowserIdSource.getVersion();
    },
  ],
};
